<div class="lp-click-activity" style="width: 100%; height: 100%">
  <app-canvas-renderer
    [elements]="elements()"
    [size]="size()"
    style="display: block; width: 100%; height: 100%"
    (clicked)="handleClick($event)"
  />
</div>
